module.exports = __webpack_public_path__ + "static/media/download.5c58b061.svg";